import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IMyDrpOptions } from 'mydaterangepicker';
import * as moment from 'moment';
import { UpdateDriversScheduleService } from './update-drivers-schedule.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-update-drivers-schedule',
  templateUrl: './update-drivers-schedule.component.html',
  styleUrls: ['./update-drivers-schedule.component.scss'],
})
export class UpdateDriversScheduleComponent implements OnInit, OnChanges {

  calendarForm: FormGroup;
  disbaledDatePicker = false;
  dateRangeDriver: any;
  arrayTime = {
    startTime: '',
    endTime: ''
  };
  myDatePickerOptionsCalendar: IMyDrpOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateRangeField: false,
    componentDisabled: false
  };
  minCharacter: number;

  @Input() selectedDriver: number;
  @Output() updateDriverEmit: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private dirverScheduleService: UpdateDriversScheduleService,
    protected loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.initFormCalendar();
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedDriver'] && this.selectedDriver) {
      this.getDataDriver();
    }
  }

  getDataDriver() {
    this.dirverScheduleService.getDriverSchedule(this.selectedDriver).subscribe((resp) => {
      if (resp) {
        this.calendarForm.reset();
        this.saveTimeAll(resp);
        this.calendarForm.patchValue(resp);
        if (resp.ptoenddate && resp.ptofromdate) {
          this.formateDate(resp.ptofromdate, resp.ptoenddate);
        }
      }
      this.validateDisabled();
    });
  }

  saveTimeAll(resp) {
    let arrayTime = [];
    if (resp.starttimemonday || resp.starttimetuesday || resp.starttimewednesday || resp.starttimethursday
      || resp.starttimefriday || resp.starttimesaturday || resp.starttimesunday) {
      arrayTime = [
        resp.starttimemonday, resp.endtimemonday, resp.starttimetuesday, resp.endtimetuesday,
        resp.starttimewednesday, resp.endtimewednesday, resp.starttimethursday, resp.endtimethursday,
        resp.starttimefriday, resp.endtimefriday, resp.starttimesaturday,
        resp.endtimesaturday, resp.starttimesunday, resp.endtimesunday
      ];
    }
    if (arrayTime.length) {
      for (let i = 0; i < arrayTime.length; i++) {
        if (arrayTime[i]) {
          this.arrayTime.startTime = arrayTime[i - 1];
          this.arrayTime.endTime = arrayTime[i];
        }
      }
    }
  }

  formateDate(fromDate, endate) {
    this.calendarForm.get('dateRange').reset();
    const startDate = moment(fromDate).format('MM-DD-YYYY');
    const endDate = moment(endate).format('MM-DD-YYYY');
    const split = startDate.split('-');
    const split2 = endDate.split('-');

    this.dateRangeDriver = {
      beginDate: {
        year: Number(split[2]),
        month: Number(split[0]) <= 9 ? split[0].substring(1) : split[0],
        day: Number(split[1]) <= 9 ? split[1].substring(1) : split[1]
      },
      endDate: {
        year: Number(split2[2]),
        month: Number(split2[0]) <= 9 ? split2[0].substring(1) : split2[0],
        day: Number(split2[1]) <= 9 ? split2[1].substring(1) : split2[1]
      },
    };

    this.calendarForm.get('dateRange').patchValue(this.dateRangeDriver);
  }

  initFormCalendar() {
    this.calendarForm = this.fb.group({
      sunday: [false],
      monday: [false],
      tuesday: [false],
      wednesday: [false],
      thursday: [false],
      friday: [false],
      saturday: [false],
      paidtimeoff: [false],
      starttimemonday: [''],
      starttimetuesday: [''],
      starttimewednesday: [''],
      starttimethursday: [''],
      starttimefriday: [''],
      starttimesaturday: [''],
      starttimesunday: [''],
      endtimemonday: [''],
      endtimetuesday: [''],
      endtimewednesday: [''],
      endtimethursday: [''],
      endtimefriday: [''],
      endtimesaturday: [''],
      endtimesunday: [''],
      ptofromdate: [''],
      ptoenddate: [''],
      mctdriverid: [],
      dateRange: ['']
    });
  }

  onSeletedDateCalendar(event) {
    if (event.formatted) {
      const split = event.formatted.split(' ');
      this.calendarForm.patchValue({
        ptofromdate: split[0],
        ptoenddate: split[2]
      });
    } else {
      this.calendarForm.get('ptoenddate').setValue('');
    }
  }

  saveDriver() {
    this.loading.show();
    this.dirverScheduleService.updateDriverSchedule(this.calendarForm.getRawValue()).subscribe((res) => {
      if (res) {
        this.swal(res).then(() => {
          this.updateDriverEmit.emit(this.calendarForm.getRawValue());
          this.getDataDriver();
          this.loading.hiden();
        });
      }
    },
      error => { this.swal(error).then(() => this.loading.hiden()); }
    );
  }

  swal(resp) {
    return this.sweetAlertHelper.createCustomAlert({
      title: resp.success ? 'Success' : 'Error',
      text: resp.message,
      type: resp.success ? 'success' : 'error'
    });
  }

  validateTime(startime, endtimes, id, event) {
    const starttime = this.calendarForm.get(startime).value;
    const endtime = this.calendarForm.get(endtimes).value;
    const data = event.replace(/[^0-9]/g, '');
    this.minCharacter = data.length;
    if (endtime && starttime) {
      if ((endtime < starttime) && data.length >= 4) {
        this.sweetAlertHelper.createCustomAlert({
          title: '',
          text: 'The end time can not be less than the start time',
          type: 'info'
        }).then(() => {
          if (id === 1) {
            this.calendarForm.get(startime).setValue(null);
          } else {
            this.calendarForm.get(endtimes).setValue(null);
          }
        });
      }
    }
    if ((data.length >= 4)) {
      if (id === 1) {
        this.arrayTime.startTime = starttime;
      } else {
        this.arrayTime.endTime = endtime;
      }
    }
    this.ValidateFormInput();
  }

  validateDisabled() {
    if (!this.calendarForm.get('sunday').value) {
      this.disabledInput('starttimesunday', 'endtimesunday');
    } else {
      this.enabledInput('starttimesunday', 'endtimesunday');
    }

    if (!this.calendarForm.get('monday').value) {
      this.disabledInput('starttimemonday', 'endtimemonday');
    } else {
      this.enabledInput('starttimemonday', 'endtimemonday');
    }

    if (!this.calendarForm.get('tuesday').value) {
      this.disabledInput('starttimetuesday', 'endtimetuesday');

    } else {
      this.enabledInput('starttimetuesday', 'endtimetuesday');
    }

    if (!this.calendarForm.get('wednesday').value) {
      this.disabledInput('starttimewednesday', 'endtimewednesday');
    } else {
      this.enabledInput('starttimewednesday', 'endtimewednesday');
    }

    if (!this.calendarForm.get('thursday').value) {
      this.disabledInput('starttimethursday', 'endtimethursday');

    } else {
      this.enabledInput('starttimethursday', 'endtimethursday');
    }

    if (!this.calendarForm.get('friday').value) {
      this.disabledInput('starttimefriday', 'endtimefriday');
    } else {
      this.enabledInput('starttimefriday', 'endtimefriday');
    }

    if (!this.calendarForm.get('saturday').value) {
      this.disabledInput('starttimesaturday', 'endtimesaturday');
    } else {
      this.enabledInput('starttimesaturday', 'endtimesaturday');
    }

    if (!this.calendarForm.get('paidtimeoff').value) {
      this.calendarForm.get('dateRange').setValue(null);
      this.disabledInput('ptofromdate', 'ptoenddate');
      this.myDatePickerOptionsCalendar = {
        componentDisabled: true
      };
    } else {
      this.enabledInput('ptofromdate', 'ptoenddate');
      this.myDatePickerOptionsCalendar = {
        componentDisabled: false
      };
    }

  }

  disabledInput(startime, endtime) {
    this.calendarForm.get(startime).setValue('');
    this.calendarForm.get(endtime).setValue('');
    this.calendarForm.controls[startime].disable();
    this.calendarForm.controls[endtime].disable();
  }

  enabledInput(startime, endtime) {
    this.calendarForm.controls[startime].enable();
    this.calendarForm.controls[endtime].enable();
    this.calendarForm.controls[startime].setValidators([Validators.required]);
    this.calendarForm.controls[endtime].setValidators([Validators.required]);
    this.calendarForm.controls[startime].updateValueAndValidity();
    this.calendarForm.controls[endtime].updateValueAndValidity();
    this.setTimeInput(startime, endtime);
  }

  isActive(event) {
    this.validateDisabled();
    if (!event) {
      this.ValidateFormInput(event);
    }
  }

  setTimeInput(startime, endtime) {
    if (this.calendarForm.get(startime).value === null && this.calendarForm.get(endtime).value === null) {
      if (this.arrayTime.startTime && this.arrayTime.endTime) {
        this.calendarForm.get(startime).setValue(this.arrayTime.startTime);
        this.calendarForm.get(endtime).setValue(this.arrayTime.endTime);
      }
    }
  }

  get disbaledBtnSave() {
    return this.calendarForm.invalid || this.minCharacter < 4;
  }

  ValidateFormInput(disabled?: boolean) {
    if (!disabled) {
      this.minCharacter = 4;
    }
    const valueForm = this.calendarForm.value;
    Object.keys(valueForm).map((key) => {
      if (key.substring(0, 5) === 'start' || key.substring(0, 4) === 'endt') {
        if (valueForm[key] && valueForm[key].replace(/[^0-9]/g, '').length < 4) {
          this.minCharacter = 0;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/update-drivers-schedule/update-drivers-schedule.component.ts